module.exports = __webpack_public_path__ + "img/ornament-block-pattern.ea456712.svg";